import { CursorPageSchema } from 'notable-common';
import { z } from 'zod';
/**
 * The list filters and page. `name` matches exactly, `q` searches, `excludedIds` drops
 * organizations the caller already holds.
 *
 * No `sort`: the handler validates a requested sort against no sortable columns, so publishing it
 * would advertise a parameter every value of which is rejected.
 */
export const OrganizationFindAllQuerySchema = z
    .object({
    name: z.string().min(1).optional(),
    q: z.string().min(1).optional(),
    excludedIds: z.array(z.uuid()).optional(),
    page: CursorPageSchema.optional(),
})
    .strict();
//# sourceMappingURL=findAll.js.map